var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResistanceMachines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 72.8333H102.917C111.738 72.8333 114 75.4261 114 83.9166C114 92.7383 111.407 94.9999 102.917 94.9999H49.0833C40.2616 94.9999 38 92.407 38 83.9166C38 75.0949 40.5926 72.8333 49.0833 72.8333Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 72.8333H102.917C111.738 72.8333 114 75.4261 114 83.9166C114 92.7383 111.407 94.9999 102.917 94.9999H49.0833C40.2616 94.9999 38 92.407 38 83.9166C38 75.0949 40.5926 72.8333 49.0833 72.8333Z",
    stroke: "url(#paint0_linear_16725_943)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 95H102.917C111.738 95 114 97.5929 114 106.083C114 114.905 111.407 117.167 102.917 117.167H49.0833C40.2616 117.167 38 114.574 38 106.083C38 97.2616 40.5926 95 49.0833 95Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 95H102.917C111.738 95 114 97.5929 114 106.083C114 114.905 111.407 117.167 102.917 117.167H49.0833C40.2616 117.167 38 114.574 38 106.083C38 97.2616 40.5926 95 49.0833 95Z",
    stroke: "url(#paint1_linear_16725_943)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 117.167H102.917C111.738 117.167 114 119.76 114 128.25C114 137.072 111.407 139.333 102.917 139.333H49.0833C40.2616 139.333 38 136.741 38 128.25C38 119.428 40.5926 117.167 49.0833 117.167Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0833 117.167H102.917C111.738 117.167 114 119.76 114 128.25C114 137.072 111.407 139.333 102.917 139.333H49.0833C40.2616 139.333 38 136.741 38 128.25C38 119.428 40.5926 117.167 49.0833 117.167Z",
    stroke: "url(#paint2_linear_16725_943)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 47.4948L134.273 41.1692C130.536 36.4976 128.667 34.1618 126.065 32.9116C123.885 31.8634 121.429 31.6941 117.166 31.6667M12.6665 47.4948L17.727 41.1692C21.4643 36.4976 23.3329 34.1618 25.934 32.9116C28.115 31.8634 30.5703 31.6941 34.8332 31.6667M101.333 31.6667H50.6665",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 47.4948L134.273 41.1692C130.536 36.4976 128.667 34.1618 126.065 32.9116C123.885 31.8634 121.429 31.6941 117.166 31.6667M12.6665 47.4948L17.727 41.1692C21.4643 36.4976 23.3329 34.1618 25.934 32.9116C28.115 31.8634 30.5703 31.6941 34.8332 31.6667M101.333 31.6667H50.6665",
    stroke: "url(#paint3_linear_16725_943)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 12.6667V72.8334M50.6665 12.6667V72.8334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 12.6667V72.8334M50.6665 12.6667V72.8334",
    stroke: "url(#paint4_linear_16725_943)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_943",
    x1: 38,
    y1: 72.8333,
    x2: 87.986,
    y2: 121.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_943",
    x1: 38,
    y1: 95,
    x2: 87.986,
    y2: 143.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_943",
    x1: 38,
    y1: 117.167,
    x2: 87.986,
    y2: 165.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_943",
    x1: 12.6665,
    y1: 31.6667,
    x2: 38.9389,
    y2: 91.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_943",
    x1: 50.6665,
    y1: 12.6667,
    x2: 112.222,
    y2: 27.4295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResistanceMachines);
export default __webpack_public_path__ + "static/media/resistance-machines.713aa767df73373c48dbde08a42da1f4.svg";
export { ForwardRef as ReactComponent };